/**
 *  directives 自定义指令
 */
import Vue from 'vue'
import i18n from '@/assets/i18n'
import {Ticket} from '@/utils';

/**
 *  v-lang 指令
 *  [参数]:
 *  show 在xx语言下展示该标签（默认）
 *  hide 在xx语言下隐藏该标签
 *  [值]:
 *  String | Array
 *  语言的缩写：zh-CN、en、es、pt-br
 *
 *  事例：
 *  v-lang="zh-CN"  v-lang:show="zh-CN" //只在中文环境下展示
 *  v-lang:hide="['en','es']"     //在这两种语言下隐藏
 */
Vue.directive('lang', {
    bind: function (el, binding, vnode) {
        let lang = binding.value  // 值  示例中的zh
        let arg = binding.arg      // 参数 示例中show
        let currentLang = i18n.locale
        // console.log(`currentLang: ${currentLang}`)
        // console.log('setting', lang)

        if (typeof lang === 'string') lang = [binding.value]

        let hide = () => {
            el.style.display = 'none'
        }

        if (!arg || arg === 'show') {
            if (!lang.includes(currentLang)) hide()
        }

        if (arg === 'hide') {
            if (lang.includes(currentLang)) hide()
        }
    }
})

/**
 * v-permission 指令
 * 包含两种值：
 *  a) userType 1 管理员 2 培训师 3 学员 4 超管
 *  b) userID  有权限的用户id
 *
 *  事例：v-permission=[1, 4, '1234567']
 */
Vue.directive('permission', {
    inserted: function (el, binding, vnode) {
        let roles = binding.value  // 值
        let arg = binding.arg      // 参数

        if (!Array.isArray(roles)) roles = [binding.value]

        let {type, userID} = Ticket.get()
        let hasPermission = roles.includes(type) || roles.includes(userID)

        if (!hasPermission) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
})
